import React from 'react';
import {mainGreen} from 'styles/variables';

const TickIcon = props => {
    return (
        <svg width='1.625rem' height='1.625rem' viewBox='0 0 26 26' {...props}>
            <g fill='none' fillRule='nonzero'>
                <path
                    fill={props.bgFill || mainGreen}
                    stroke={props.stroke || '#FFF'}
                    strokeWidth='2'
                    d='M13 22.412a9.412 9.412 0 1 1 0-18.824 9.412 9.412 0 0 1 0 18.824z'
                />
                <path fill='#FFF' d='M12.08 14.624l4.922-4.844.875.862-5.796 5.705-3.508-3.452.875-.862z' />
            </g>
        </svg>
    );
};

export default TickIcon;
